import { useTranslation } from "react-i18next";
import FeatureDashboard from "../../../components/base/FeatureDashboard";
import { useBasesStore } from "../store";

// Reservas overview — stats derived from the shared store (amenities + bookings)
// so the numbers stay in sync with what Amenidades configures.
export default function ReservasDashboard() {
  const { t } = useTranslation("common");
  const amenities = useBasesStore((s) => s.amenities);
  const bookings = useBasesStore((s) => s.bookings);

  const confirmed = bookings.filter((b) => b.status === "Confirmada").length;
  const pending = bookings.filter((b) => b.status === "Por confirmar").length;

  // Bookings per weekday (Mon..Sun) for the mini chart.
  const labels = t("basesPropiedades.weekdaysShort", {
    returnObjects: true,
  }) as string[];
  const counts = new Array(7).fill(0);
  for (const b of bookings) {
    const d = new Date(`${b.date}T00:00:00`);
    if (!Number.isNaN(d.getTime())) {
      const idx = (d.getDay() + 6) % 7; // Mon=0
      counts[idx] += 1;
    }
  }

  const recent = [...bookings]
    .sort((a, b) => (a.date < b.date ? 1 : -1))
    .slice(0, 4)
    .map((b) => ({
      primary: `${b.amenityName} — ${b.customerName}`,
      secondary: `${b.date} ${b.startTime}`,
      badge: t(`basesPropiedades.bookingStatus.${b.status}`, b.status),
      tone:
        b.status === "Confirmada"
          ? ("ok" as const)
          : b.status === "Cancelada"
            ? ("danger" as const)
            : ("warn" as const),
    }));

  return (
    <FeatureDashboard noticeKey="nuvexAccess.mockNotice"
      title={t("basesPropiedades.reservas.dashboardTitle")}
      subtitle={t("basesPropiedades.reservas.dashboardSubtitle")}
      icon="ri-calendar-check-line"
      stats={[
        {
          label: t("basesPropiedades.reservas.statBookings"),
          value: String(bookings.length),
          icon: "ri-calendar-check-line",
        },
        {
          label: t("basesPropiedades.reservas.statAmenities"),
          value: String(amenities.length),
          icon: "ri-community-line",
        },
        {
          label: t("basesPropiedades.reservas.statConfirmed"),
          value: String(confirmed),
          icon: "ri-checkbox-circle-line",
        },
        {
          label: t("basesPropiedades.reservas.statPending"),
          value: String(pending),
          icon: "ri-time-line",
        },
      ]}
      chart={{
        title: t("basesPropiedades.reservas.chartTitle"),
        data: labels.map((name, i) => ({ name, value: counts[i] })),
      }}
      recent={{
        title: t("basesPropiedades.reservas.recentTitle"),
        items: recent,
      }}
    />
  );
}
